<button class="button icon clean" (click)="toggleTheme()">
  <ly-icon [icon]="iconName"></ly-icon>
</button>
